/**
 * Author : Komal Sadrani
 * Changes : Aaditya Gandhare
 * Modified : 13th Aug, 2018
 */

/**
 * Ext Libs
 */
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {LocalStorageService} from 'ngx-store';
import {BaseSettingsService} from '../../providers/base-settings.service';

/**
 * Services
 */
import {ConsignmentService} from '../../providers/consignment.service';

@Component({
  selector: 'app-consignments',
  templateUrl: './consignments.component.html',
  styleUrls: ['./consignments.component.css']
})
export class ConsignmentsComponent implements OnInit {
  public websiteURL: string;
  public baseHREF: string;
  private sessionUser: any;
  public consignments: any;

  // Loader
  public loading: boolean;
  // Errors
  public fetchError: number;
  public errorMessage: string;
  public errorSubMessage: string;

  private referrer: string;
  private file_name: string;

  /**
   * Initialize the class
   */
  constructor(private router: Router, private consignmentService: ConsignmentService,
              private localStorage: LocalStorageService, private baseProvider: BaseSettingsService, private activatedRoute: ActivatedRoute) {
    // Base
    this.websiteURL = this.baseProvider.websiteURL;
    this.baseHREF = this.baseProvider.baseHREF;

    // Defaults
    this.consignments = [];

    // Loader
    this.loading = false;
  }

  /**
   * On Init Lifecycle Hook
   */
  ngOnInit() {
    // Check current ongoing session
    this.checkSession();
    // Get the Id of the Customer from the URL
    this.activatedRoute.params.subscribe((params: Params) => {
      this.referrer = params['referrer'];
      this.file_name = params['file_name'];
      console.log(this.referrer);
      console.log(this.file_name);
      if (this.referrer !== undefined && this.file_name !== undefined) {
        console.log('Download starting');
        const pdf_url = `https://cdn.chemfields.com/downloads/${this.file_name}.pdf`;
        console.log(pdf_url);
        window.open(pdf_url, '_blank');
      }
    });
  }

  /**
   * Get Current Session
   */
  checkSession() {
    let customer = this.localStorage.get('customer-session');
    // Check If Customer ID exists
    if (customer && customer.id) {
      this.sessionUser = customer;
      // Get Consginments Listing
      this.getConsignmentsListing();
    }

    // Check If Customer ID does not exist
    if (!customer) {
      // If so, redirect to login
      this.router.navigate(['/login']);
    }
  }

  /**
   * Get Consignments Listing
   */
  getConsignmentsListing() {
    this.loading = true;

    let params = {
      'related_customer_id_c': this.sessionUser.id
    };

    this.consignmentService.listing(params).subscribe(
      (data) => {
        this.handleConsignmentResponseSucceess(data);
      },
      (err) => {
        this.handleConsignmentResponseError(err);
      },
    );
  }

  /**
   * Handle Consignments Succeess Response
   */
  handleConsignmentResponseSucceess(response) {
    this.loading = false;

    if (response.status == 'SUCCESS') {
      this.consignments = response.consignments;
      this.fetchError = 200;
    }
  }

  /**
   * Handle Consignments Error Response
   */
  handleConsignmentResponseError(err) {
    this.loading = false;
    let message = '';
    let submessage = '';
    this.fetchError = err.status;

    // Bad Data or No data to the server
    if (err.status == 400) {
      message = 'Access Denied!';
      submessage = 'Bad data passed!';
    }

    // Bad Data or No data to the server
    if (err.status == 404) {
      message = 'No consignments for you yet';
      submessage = 'Please contact Chemfield Admin in case of any issues';
    }

    // Access Denies
    if (err.status == 403) {
      message = 'Access Denied!';
      submessage = 'Please check the data you have entered';
    }

    // Username or Password does not match
    if (err.status == 409) {
      message = 'Login Failure!';
      submessage = 'Username or Password does not match';
    }

    // Error from Server
    if (err.status == 500) {
      message = 'Something Went Wrong!';
      submessage = 'There seems to be something wrong at the moment. Please try again later.';
    }

    // No Network Error
    if (err.status == -1) {
      message = 'Network Error!';
      submessage = 'No Internet Connection. Please try to connect to a network and try again.';
    }

    this.errorMessage = message;
  }

  /**
   * Go to Details Page
   */
  goToDetails(id: string) {
    this.router.navigate(['/consignment-detail', id]);
  }
}
